// src/redux/slices/statusHistorySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { base_url } from '../../api/api-url';

// Async thunk
export const fetchStatusHistory = createAsyncThunk(
  'statusHistory/fetchStatusHistory',
  async (ticketId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${base_url}/status-history/${ticketId}`, {
       
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const statusHistorySlice = createSlice({
  name: 'statusHistory',
  initialState: {
    history: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearHistory: (state) => {
      state.history = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStatusHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStatusHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.history = action.payload.data;
      })
      .addCase(fetchStatusHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch status history';
      });
  },
});

export const { clearHistory } = statusHistorySlice.actions;
export default statusHistorySlice.reducer;
